import {
  GET_USER,
  GET_USERS_BY_IDS,
  SUGGEST_USERS,
  GET_USER_SYSTEMS_SUCCESS,
  GET_USER_SYSTEMS_ERROR,
  GET_USER_PREFERENCES,
  GET_USER_PREFERENCES_ERROR,
  GET_USER_PREFERENCES_SUCCESS,
  UPDATE_USER_PREFERENCES,
  UPDATE_USER_PREFERENCES_ERROR,
  UPDATE_USER_PREFERENCES_SUCCESS,
  SET_ACTIVE_USER,
  UPDATE_ACTIVE_USER,
  GET_DIRECT_REPORTS,
  GET_DIRECT_REPORTS_WITH_TIME,
  GET_DIRECT_REPORTS_WITH_TIME_SUCCESS,
  GET_DIRECT_REPORTS_WITH_TIME_ERROR,
  RESET_DIRECT_REPORTS_WITH_TIME,
} from './types';
import { success, error } from '../utils';
import { SupportedSystems } from '../../shared';
import { isArrayWithLength, appendDirectReport } from '../../helpers';

const initialState = {
  token: null,
  activeUser: null,
  systems: [],
  getUser: {
    isLoading: false,
    isError: false,
    data: null,
  },
  getUsersByIds: {
    isLoading: false,
    isError: false,
    data: [],
  },
  getDirectReports: {
    isLoading: false,
    isError: false,
    pageNumber: null,
    totalCount: null,
    data: [],
  },
  suggestUsers: {
    isLoading: false,
    isError: false,
    data: [],
  },
  preferences: {
    isLoading: false,
    isError: false,
    data: {},
  },
  savePreferences: {
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  directReportsWithTime: {
    isLoading: false,
    isError: false,
    data: [],
  },
  systemsRequested: false,
};

export const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case SET_ACTIVE_USER:
      return {
        ...state,
        activeUser: {
          ...state.activeUser,
          ...action.data,
        },
      };
    case UPDATE_ACTIVE_USER:
      return {
        ...state,
        activeUser: {
          ...state.activeUser,
          oid: action.oid,
        },
      };
    case GET_USER:
      return {
        ...state,
        getUser: {
          ...state.getUser,
          isLoading: true,
          isError: false,
        },
      };
    case success(GET_USER):
      return {
        ...state,
        getUser: {
          ...state.getUser,
          isLoading: false,
          isError: false,
          data: action.payload,
        },
      };
    case error(GET_USER):
      return {
        ...state,
        getUser: {
          ...state.getUser,
          isLoading: false,
          isError: true,
        },
      };

    case GET_USERS_BY_IDS:
      return {
        ...state,
        getUsersByIds: {
          ...state.getUsersByIds,
          isLoading: true,
          isError: false,
        },
      };
    case success(GET_USERS_BY_IDS):
      return {
        ...state,
        getUsersByIds: {
          ...state.getUsersByIds,
          isLoading: false,
          isError: false,
          data: action.payload,
        },
      };
    case error(GET_USERS_BY_IDS):
      return {
        ...state,
        getUsersByIds: {
          ...state.getUsersByIds,
          isLoading: false,
          isError: true,
        },
      };

    case GET_DIRECT_REPORTS:
      return {
        ...state,
        getDirectReports: {
          ...state.getDirectReports,
          isLoading: true,
          isError: false,
        },
      };
    case success(GET_DIRECT_REPORTS):
      return {
        ...state,
        getDirectReports: {
          ...state.getDirectReports,
          isLoading: false,
          isError: false,
          pageNumber: action.payload.page,
          totalCount: action.payload.totalCount,
          data: action.payload.data,
        },
      };
    case error(GET_DIRECT_REPORTS):
      return {
        ...state,
        getDirectReports: {
          ...state.getDirectReports,
          isLoading: false,
          isError: true,
        },
      };

    case GET_DIRECT_REPORTS_WITH_TIME:
      return {
        ...state,
        directReportsWithTime: {
          ...state.directReportsWithTime,
          isLoading: true,
          isError: false,
        },
      };
    case GET_DIRECT_REPORTS_WITH_TIME_SUCCESS: {
      let updatedData;

      if (
        !state.directReportsWithTime.data ||
        state.directReportsWithTime.data.length === 0
      ) {
        updatedData = action.results;
      } else {
        updatedData = appendDirectReport(
          state.directReportsWithTime.data,
          action.results || [],
          action.id
        );
      }
      return {
        ...state,
        directReportsWithTime: {
          ...state.directReportsWithTime,
          isLoading: false,
          isError: false,
          totalCount: action.results.totalCount,
          data: updatedData,
        },
      };
    }
    case GET_DIRECT_REPORTS_WITH_TIME_ERROR:
      return {
        ...state,
        directReportsWithTime: {
          ...state.directReportsWithTime,
          isLoading: false,
          isError: true,
        },
      };

    case RESET_DIRECT_REPORTS_WITH_TIME:
      return {
        ...state,
        directReportsWithTime: {
          ...state.directReportsWithTime,
          isLoading: false,
          isError: false,
          data: [],
        },
      };

    case SUGGEST_USERS:
      return {
        ...state,
        suggestUsers: {
          ...state.suggestUsers,
          isLoading: true,
          isError: false,
        },
      };
    case success(SUGGEST_USERS):
      return {
        ...state,
        suggestUsers: {
          ...state.suggestUsers,
          isLoading: false,
          isError: false,
          data: action.payload,
        },
      };
    case error(SUGGEST_USERS):
      return {
        ...state,
        suggestUsers: {
          ...state.suggestUsers,
          isLoading: false,
          isError: true,
        },
      };

    case GET_USER_SYSTEMS_SUCCESS:
      return {
        ...state,
        systems: isArrayWithLength(action.payload)
          ? action.payload
          : [SupportedSystems.VPIN],
        systemsRequested: true,
      };
    case GET_USER_SYSTEMS_ERROR:
      return {
        ...state,
        systemsRequested: true,
      };
    case GET_USER_PREFERENCES:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          isLoading: true,
          isError: false,
        },
      };
    case GET_USER_PREFERENCES_ERROR:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          isLoading: false,
          isError: true,
        },
      };
    case GET_USER_PREFERENCES_SUCCESS:
      return {
        ...state,
        preferences: {
          data: {
            ...action.payload,
          },
          isLoading: false,
          isError: false,
        },
      };
    case UPDATE_USER_PREFERENCES:
      return {
        ...state,
        savePreferences: {
          ...state.savePreferences,
          isLoading: true,
          isError: false,
          isSuccess: false,
        },
      };
    case UPDATE_USER_PREFERENCES_ERROR:
      return {
        ...state,
        savePreferences: {
          ...state.savePreferences,
          isLoading: false,
          isError: true,
          isSuccess: false,
        },
      };
    case UPDATE_USER_PREFERENCES_SUCCESS:
      return {
        ...state,
        savePreferences: {
          ...state.savePreferences,
          isLoading: false,
          isError: false,
          isSuccess: true,
        },
      };
    default:
      return state;
  }
};
